// event 模块 url 地址管理
export const url = {
    // publice
    upload: '/auth/public/upload_file', // 上传图片和文件
    uploadWatermark: '/auth/public/uploadFile/water', // 上传图片和文件
    selectBySegment: '/manage/event/selectBySegment', // event中下拉选择
    disableAndEnable: '/manage/event/updateHidden', //event中的显示隐藏
    eventStatusUpdate: '/manage/event/eventStatusUpdate', // event的上线,下线
    checkWeigth: '/manage/event/checkWeight', // event中weight的校验
    // privete
    activityAdd: '/manage/event/add', //basf活动的添加
    activityList: '/manage/event/list', // basf活动的列表
    activityDetail: '/manage/event/detail', // 活动详情
    activityUpdate: '/manage/event/update', // 活动修改
    speakerList: '/manage/event/speaker/list', // event中speaker的列表
    speakerTimeAndAddress: '/manage/event/speakerAddress/addAndUpdate' ,  // event中speaker的添加和修改
    speakerAddressDetail: '/manage/event/speakerAddress/detail', // event中演讲地址,时间的详情
    speakerAddressAddAndUpdate: '/manage/event/speaker/addAndUpdate',  // event中speaker的添加和修改
    speakerDetail: '/manage/event/speaker/detail',  // spearker的详情
    formulationCategoryList: '/manage/event/formulationSegment/list', // event中formulation的分类的列表
    formulationCategoryAddAndUpdate: '/manage/event/formulationSegment/addAndUpdate', // event中formulation的分类添加/修改
    formulationCategoryDetail: '/manage/event/formulationSegment/detail',  // event中formulation的分类的详情
    formulationList: '/manage/event/formulation/list', // event中formulation的列表
    formulationAddAndUpdate: '/manage/event/formulation/addAndUpdate', //  event中formulation的添加/修改
    formulationDetail: '/manage/event/formulation/detail', // event中formulation的详情
    productCategoryList: '/manage/event/tradeSegment/list', // event中basf_product的的分类列表
    productCategoryUpdate :'/manage/event/tradeSegment/addAndUpdate', // event中basf_product的的分类添加/修改
    productCategoryDetail: '/manage/event/tradeSegment/detail',  // event中basf_product的的分类详情
    solutionList: '/manage/event/solution/list', // event中solution的列表
    solutionAddAndUpdate: '/manage/event/solution/addAndUpdate', // event中solution的添加/修改
    solutionDetail: '/manage/event/solution/detail', // event中solution的详情
    productAddAndUpdate: '/manage/event/tradeName/addAndUpdate', // event中basf_product的添加/修改
    productDetail: '/manage/event/tradeName/detail',  // event中basf_product的详情
    productList: '/manage/event/tradeName/list', // event中basf_product的列表
    exportComment: '/manage/event/exportComment', // event的评论导出
    exportLog: '/manage/event/exportLog', // event的日志导出
    deleteEvent: '/manage/event/delete', // 删除
    searchTrade: '/manage/event/trade/search', // 远程搜索trade
    searchFormulation: '/manage/event/formulation/search', // 远程搜索formulation
    getExportTotal: '/manage/event/exportTotal',
    delSpeaker: '/manage/event/speaker/delete',
    delBasfProductSegment: '/manage/event/tradeSegment/delete',
    delBasfProduct: '/manage/event/tradeName/delete',
    delFormulationSegment: '/manage/event/formulationSegment/delete',
    delFormulation: '/manage/event/formulation/delete',
    trendList: '/manage/event/trend/list',
    trendAddAndUpdate: '/manage/event/trend/addAndUpdate',
    trendDetail: '/manage/event/trend/detail',
    delTrend: '/manage/event/trend/delete',
    conceptList: '/manage/event/concept/list',
    conceptAddAndUpdate: '/manage/event/concept/addAndUpdate',
    conceptDetail: '/manage/event/concept/detail',
    delConcept: '/manage/event/concept/delete',
    searchConceptList: '/manage/event/concept/search',
    searchTrend: '/manage/event/trend/search'
} 
 


// WEBPACK FOOTER //
// ./src/axios/api_urls/event.js